import { GetMaterializedApprovalsFlowsDocument } from 'generated/resources/graphql'
import groupBy from 'lodash/groupBy'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useLazyQuery } from 'modules/core/hooks/useQuery'

interface PendingApprovalFlowsData {
  category: string
  totalPending: number
}

export const useEmployeePendingApprovalFlows = (
  ownerId: number,
  companyId: number
): PendingApprovalFlowsData[] => {
  const [fetchMaterializedApprovalsFlows, { data }] = useLazyQuery(
    GetMaterializedApprovalsFlowsDocument,
    {
      variables: {
        ownerId,
        companyId,
        status: 'running',
      },
    }
  )

  useEffect(() => {
    fetchMaterializedApprovalsFlows()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ownerId])

  const pendingApprovalFlows = data?.approvals?.materializedApprovalsFlowsConnection?.nodes || []

  const approvalFlowByResourceType = groupBy(pendingApprovalFlows, (flow) => flow.resourceType)

  return Object.keys(approvalFlowByResourceType || {}).reduce<PendingApprovalFlowsData[]>(
    (acc, resourceType) => {
      const category = resourceType.split('::').pop()
      if (!category) {
        return acc
      }
      return [
        ...acc,
        {
          totalPending: approvalFlowByResourceType[resourceType]?.length || 0,
          category: category.toLowerCase(),
        },
      ]
    },
    []
  )
}
